
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "@/components/ui/sonner";
import { ArrowRight, Lock } from "lucide-react";

// This password should be changed to something more secure
const SITE_PASSWORD = "solana123";

interface PasswordProtectionProps {
  children: React.ReactNode;
}

const PasswordProtection = ({ children }: PasswordProtectionProps) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Check if the user is already authenticated
    const authState = localStorage.getItem("password-authenticated");
    if (authState === "true") {
      setIsAuthenticated(true);
    }
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    // Simulate network delay for better UX
    setTimeout(() => {
      if (password === SITE_PASSWORD) {
        localStorage.setItem("password-authenticated", "true");
        setIsAuthenticated(true);
        toast.success("Access granted");
      } else {
        toast.error("Incorrect password");
      }
      setIsLoading(false);
    }, 500);
  };

  if (isAuthenticated) {
    return <>{children}</>;
  }

  return (
    <div className="password-protection-page min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-whirlpool-blue to-whirlpool-dark p-4">
      <div className="w-full max-w-md bg-black/30 backdrop-blur-md rounded-lg border border-whirlpool-light/20 shadow-xl p-6">
        <div className="flex items-center justify-center mb-6">
          <Lock className="h-8 w-8 text-whirlpool-cyan" />
        </div>
        
        <h1 className="text-2xl font-bold text-center text-white mb-2">Protected Area</h1>
        <p className="text-whirlpool-light text-center mb-6">Please enter the password to continue</p>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
            autoFocus
            className="bg-black/40 border-whirlpool-blue/30 text-white"
            disabled={isLoading}
          />
          
          <Button 
            type="submit" 
            className="w-full bg-gradient-to-r from-whirlpool-blue to-whirlpool-cyan hover:from-whirlpool-cyan hover:to-whirlpool-blue transition-all duration-300" 
            disabled={isLoading}
          >
            {isLoading ? "Checking..." : "Continue"} 
            {!isLoading && <ArrowRight className="ml-2 h-4 w-4" />}
          </Button>
        </form>
      </div>
      
      <p className="text-whirlpool-light/70 text-sm mt-8">
        If you need access, please contact the administrator.
      </p>
    </div>
  );
};

export default PasswordProtection;
